module.exports = __webpack_public_path__ + "static/media/vintage.95b1692e.svg";